module.exports = __webpack_public_path__ + "img/camera.469f8627.png";